<template>
  <div class="img">
    <el-image
      :src="`https://secbench-1258476245.cos.ap-guangzhou.myqcloud.com/secbench/certificate/${id}.png`"
      fit="contain"
    ></el-image>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: this.$route.params.id,
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.img {
  width: calc(100% - 40px);
  margin: 48px auto 0 auto;
  height: calc(100% - 48px - 65px - 55px);
  padding-top: 20px;
  overflow: hidden;
}
</style>
<style lang="less">
html,
body,
body > div,
.el-image {
  width: 100%;
  height: 100%;
}
body {
  min-width: auto;
}
</style>
